var regex = /^(:|\[|>|&)/;

export default function isNestedSelector(property) {
  return regex.test(property);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-validator/node_modules/fela-utils/es/isNestedSelector.js
// module id = 922
// module chunks = 0